import { Controller } from 'libraries/front-end-core/core/Router'
import Main from './Main'
import Header from './Header'
import getUrl from 'libraries/front-end-core/core/url'
import { CURRENT_AWARENESS, CURRENT_AWARENESS_REVIEW } from 'constants/controllers'
import { URL_PDF_CA } from 'constants/urls'

export default new Controller({
  name: CURRENT_AWARENESS_REVIEW,
  route: '(:aol/)careview/:selectedIds',
  controller (
    Router,
    { url: pageId, scrollMain, query: { short }, params: { aol, selectedIds } },
    render
  ) {
    render(
      { Header, Main },
      {
        selectedIds: selectedIds.split(','),
        aol,
        short,
        pdfUrl: URL_PDF_CA,
        returnUrl: getUrl(CURRENT_AWARENESS, { aol }),
        type: 'ca'
      },
      {
        aol,
        pageId,
        searchType: 'ca',
        className: 'ca',
        feedbackOptions: ['ca']
      }
    )

    return pageId
  }
})
